export default "images/user-info-image.jpg";